// Derive a readable black/white text color for a given background color using
// YIQ perceived brightness (the same heuristic Typeform uses for button text).
export function contrastingTextColor(backgroundHex: string): string {
  const hex = backgroundHex.replace('#', '')
  const full = hex.length === 3 ? hex.split('').map(c => c + c).join('') : hex
  const r = parseInt(full.slice(0, 2), 16)
  const g = parseInt(full.slice(2, 4), 16)
  const b = parseInt(full.slice(4, 6), 16)
  if ([r, g, b].some(Number.isNaN)) return '#FFFFFF'
  const yiq = (r * 299 + g * 587 + b * 114) / 1000
  return yiq >= 150 ? '#000000' : '#FFFFFF'
}
